import { Row } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import {
  FooterSection,
  LogoContainer
} from "./styles";


const Footer = ({ t }: { t: TFunction }) => {

  return (
    <>
      <FooterSection>
        <Container>
             <Row
            justify="space-between"
            align="middle"
          >
              <LogoContainer>
                <SvgIcon src="s&slogo_color_logo.png" width="160px" height="31px"/>
              </LogoContainer>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
